import React from 'react';
import { AdditionalDepositInput } from './AdditionalDepositInput';

export const AdditionalDepositInfo: React.FC = () => {
  return (
    <>
      <AdditionalDepositInput />
    </>
  );
};
